import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

import type { RootState } from "~/store/store"
import type { IBOL } from "~/types/bol"

export interface ISelectedBOL extends IBOL {}

export interface BOLState {
  selectedBOL?: ISelectedBOL
}

export const initialBOLState: BOLState = {}

export const BOLManagementSlice = createSlice({
  name: "bol-management",
  initialState: initialBOLState,
  reducers: {
    setSelectedBOL: (state, action: PayloadAction<IBOL>) => {
      state.selectedBOL = {
        ...action.payload,
      }
    },
  },
})

export const useBOLManagement = (): BOLState =>
  useSelector((state: RootState) => state.bolManagement)

export const { setSelectedBOL } = BOLManagementSlice.actions

export default BOLManagementSlice.reducer
